"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Card_1 = __importDefault(require("@mui/material/Card"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
var CardMedia_1 = __importDefault(require("@mui/material/CardMedia"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var material_1 = require("@mui/material");
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var material_2 = require("@mui/material");
// import  {useNavigate} from 'react-router-dom'
var ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
var functions_1 = require("../../interfaces/functions");
var functions_2 = require("../../interfaces/functions");
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
function Wishlistcard(props) {
    // const navigate = useNavigate();
    var _a = react_1.default.useState(false), openbox = _a[0], setOpen = _a[1];
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleCloseConfirmation = function () {
        setOpen(false);
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { key: props.id, sx: {
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2px",
            } },
            react_1.default.createElement(Box_1.default, { sx: { display: "flex" } },
                react_1.default.createElement(CardMedia_1.default, { sx: { width: 151 }, component: "img", image: props.image }),
                react_1.default.createElement(CardContent_1.default, null,
                    react_1.default.createElement(Box_1.default, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        } },
                        react_1.default.createElement(material_1.Typography, { component: "h1", variant: "h5", sx: { fontWeight: 100 } }, props.name),
                        react_1.default.createElement(material_1.Typography, { component: "p" }, props.description),
                        react_1.default.createElement(material_1.Typography, { component: "h2", sx: { fontWeight: 600 } },
                            "RWF ",
                            props.price)))),
            react_1.default.createElement(Box_1.default, { sx: { display: { xs: "block", sm: "none" } } },
                react_1.default.createElement(IconButton_1.default, { "aria-label": "more", id: "long-button", "aria-controls": open ? "long-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: handleClick },
                    react_1.default.createElement(MoreVert_1.default, null)),
                react_1.default.createElement(Menu_1.default, { id: "long-menu", MenuListProps: {
                        "aria-labelledby": "long-button",
                    }, anchorEl: anchorEl, open: open, onClose: handleClose },
                    react_1.default.createElement(MenuItem_1.default, { onClick: function () {
                            handleClose();
                            (0, functions_1.AddToCart)(props.productId);
                        } }, "Add To Cart"),
                    react_1.default.createElement(MenuItem_1.default, { onClick: function () {
                            handleClose();
                            handleClickOpen();
                        } }, "Delete"))),
            react_1.default.createElement(Box_1.default, { sx: { display: { xs: "none", sm: "block" } } },
                react_1.default.createElement(CardContent_1.default, { sx: {
                        display: { xs: "flex" },
                        flexDirection: "column",
                        justifyContent: "space-between",
                    } },
                    react_1.default.createElement(material_2.Button, { size: "small", color: "primary", startIcon: react_1.default.createElement(ShoppingCart_1.default, null), variant: "outlined", onClick: function () { return (0, functions_1.AddToCart)(props.productId); } },
                        " ",
                        "Add To Cart",
                        " "),
                    react_1.default.createElement(material_2.Button, { size: "small", startIcon: react_1.default.createElement(DeleteForever_1.default, null), variant: "outlined", onClick: function () {
                            handleClose();
                            handleClickOpen();
                        } },
                        " ",
                        "remove")))),
        react_1.default.createElement(Dialog_1.default, { open: openbox, onClose: handleCloseConfirmation, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, "Delete Product from wishlist"),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(DialogContentText_1.default, { id: "alert-dialog-description" },
                    react_1.default.createElement("img", { src: props.image, alt: "".concat(props.name), loading: "lazy", width: "30", height: "35" }),
                    "Are you sure you want to delete ",
                    props.name,
                    " form your wishlist")),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(material_2.Button, { onClick: handleCloseConfirmation }, "Cancel"),
                react_1.default.createElement(material_2.Button, { onClick: function () {
                        handleCloseConfirmation();
                        (0, functions_2.RemoveWishlistItem)(props.productId);
                        props.Delete(props.productId);
                    } }, "yes")))));
}
Wishlistcard.propTypes = {};
exports.default = Wishlistcard;
